

// var TwaSettingsSwiper = {
//     init: function() {
//         this.TwaSettingsCarousel()
//     },
//     TwaSettingsCarousel: function() {
//         document.querySelectorAll(".twa__swiper").forEach(e => {
//             this.TwaCarousel(e)
//         })
//     },
//     TwaCarousel: function(e) {
//         var t = e?.dataset.autoplay === "true",
//             n = e.dataset.loop === "true",
//             w = e?.dataset.rows ? e?.dataset.row : 1,
//             o = e?.dataset.slideshow ? e?.dataset.slideshow : 0,
//             pgm = e?.dataset.spgmobile ? e?.dataset.spgmobile : 1,
//             pgt = e?.dataset.spgtablet ? e?.dataset.spgtablet : 1,
//             pgd = e?.dataset.spgdesktop ? e?.dataset.spgdesktop : 1,
//             i = e?.dataset.desktop ? e?.dataset.desktop : 4,
//             s = e?.dataset.tablet ? e?.dataset.tablet : 2,
//             r = e?.dataset.mobile ? e?.dataset.mobile : 1,
//             a = e?.dataset.autoplaySpeed ? e?.dataset.autoplaySpeed : 3e3,
//             c = e?.dataset.speed ? e?.dataset.speed : 400,
//             l = e?.dataset.effect ? e?.dataset.effect : "slide",
//             d = e?.dataset.sectionId,
//             u = e?.dataset.row ? e?.dataset.row : 1,
//             ut = e?.dataset.rowtablet ? e?.dataset.rowtablet : 1,
//             um = e?.dataset.rowmobile ? e?.dataset.rowmobile : 1,
//             p = window.innerWidth,
//             m = e?.dataset.spacing ? e?.dataset.spacing : 0;
//             cs = e.dataset.centerslide === "true", desktop = parseInt(pgd), tablet = parseInt(pgt), mobile = parseInt(pgm), al = e?.dataset.arrowleft ? e?.dataset.arrowleft : "swiper-button-prev", ar = e?.dataset.arrowright ? e?.dataset.arrowright : "swiper-button-next", m = Number(m), a = Number(a), c = Number(c), p <= 767 ? m >= 15 && (m = 15) : p <= 1199 && m >= 30 && (m = 30), new Swiper("#twa__swiper-" + d, {
//             slidesPerView: r,
//             slidesPerColumn: w,
//             autoWidth: true,
//             slidesPerGroup: mobile,
//             spaceBetween: m,
//             centeredSlides: cs,
//             autoplay: t,
//             delay: a,
//             loop: n,
//             effect: l,
//             speed: c,
//             watchSlidesProgress: !0,
//             watchSlidesVisibility: !0,
//             draggable: !0,
//             grid: {
//                 rows: um,
//                 fill: "row"
//             },
//             navigation: {
//                 nextEl: `.${ar}`,
//                 prevEl: `.${al}`
//             },
//             pagination: {
//                 clickable: !0,
//                 el: e.querySelector(".swiper-pagination")
//             },
//             breakpoints: {
//                 768: {
//                     slidesPerView: s,
//                     centeredSlides: cs,
//                     slidesPerGroup: tablet,
//                     grid: {
//                         rows: ut,
//                         fill: "row"
//                     }
//                 },
//                 1100: {
//                     slidesPerView: i,
//                     slidesPerGroup: desktop,
//                     grid: {
//                         rows: u,
//                         fill: "row"
//                     }
//                 }
//             }
//         })
//     }
// };
// TwaSettingsSwiper.init(), document.addEventListener("shopify:section:load", function(event) {
//     TwaSettingsSwiper.init()
// })


// // document.querySelectorAll('.swiper-container').forEach(swiperContainer => {
// //     const sliderId = swiperContainer.getAttribute('data-slider');
// //     const swiperConfig = {
// //         pagination: {
// //             el: `.swiper-container[data-slider="${sliderId}"] .swiper-pagination`,
// //             clickable: true,
// //             //type: "fraction"
// //         },
// //         navigation: {
// //             nextEl: `.swiper-container[data-slider="${sliderId}"] .swiper-button-next`,
// //             prevEl: `.swiper-container[data-slider="${sliderId}"] .swiper-button-prev`
// //         },
// //         slidesPerView: 1.4,
// //         slidesPerColumn: 1,
// //         spaceBetween: 20,
// //         cssMode: true,
// //         loop: false,
// //         mousewheel: false,
// //         keyboard: true,
// //         allowTouchMove: false,
// //         breakpoints: {
// //             0: { slidesPerView: 1.4, slidesPerGroup: 1, spaceBetween: 15 },
// //             768: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 30 },
// //             960: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 40 }
// //         }
// //     };
// //     let swiper = new Swiper(`.swiper-container[data-slider="${sliderId}"]`, swiperConfig);
// //     const filters = document.querySelectorAll(`.categories[data-slider="${sliderId}"] span`);
// //     function updateFilter(activeFilter) {
// //         if (!activeFilter) {
// //             filters[0].classList.add('active');
// //             activeFilter = filters[0];
// //         }
// //         const filter = activeFilter.getAttribute('data-filter').toLowerCase();
// //         filters.forEach(el => el === activeFilter ? el.classList.add('active') : el.classList.remove('active'));
// //         if (filter === 'all') {
// //             document.querySelectorAll(`.swiper-container[data-slider="${sliderId}"] [data-filter]`).forEach(item => {
// //                 item.classList.remove('non-swiper-slide');
// //                 item.classList.add('swiper-slide');
// //             });
// //         } else {
// //             document.querySelectorAll(`.swiper-container[data-slider="${sliderId}"] [data-filter]:not([data-filter='${filter}'])`).forEach(item => {
// //                 item.classList.add('non-swiper-slide');
// //                 item.classList.remove('swiper-slide');
// //                 item.removeAttribute('style');
// //             });

// //             document.querySelectorAll(`.swiper-container[data-slider="${sliderId}"] [data-filter='${filter}']`).forEach(item => {
// //                 item.classList.remove('non-swiper-slide');
// //                 item.classList.add('swiper-slide');
// //                 item.removeAttribute('style');
// //             });
// //         }
// //         swiper.update();
// //     }
// //     filters.forEach(filter => {
// //         filter.addEventListener('click', function (e) {
// //             updateFilter(e.target);
// //         });
// //     });
// //     updateFilter(null);
// // });



// document.querySelectorAll('.swiper-container').forEach(swiperContainer => {
//     const sliderId = swiperContainer.getAttribute('data-slider');
//     const swiperConfig = {
//         pagination: {
//             el: `.swiper-container[data-slider="${sliderId}"] .swiper-pagination`,
//             clickable: true,
//         },
//         navigation: {
//             nextEl: `.swiper-container[data-slider="${sliderId}"] .swiper-button-next`,
//             prevEl: `.swiper-container[data-slider="${sliderId}"] .swiper-button-prev`
//         },
//         slidesPerView: 1.4,
//         slidesPerColumn: 1,
//         spaceBetween: 20,
//         cssMode: true,
//         loop: false,
//         mousewheel: false,
//         keyboard: true,
//         allowTouchMove: false,
//         breakpoints: {
//             0: { slidesPerView: 1.4, slidesPerGroup: 1, spaceBetween: 15 },
//             768: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 30 },
//             960: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 40 }
//         }
//     };

//     let swiper = new Swiper(`.swiper-container[data-slider="${sliderId}"]`, swiperConfig);

//     const filters = document.querySelectorAll(`.categories[data-slider="${sliderId}"] span`);

//     function updateFilter(activeFilter) {
//         // If there are no filters, return early to avoid errors
//         if (filters.length === 0) {
//             console.warn('No filters found for this slider.');
//             return;
//         }

//         // If no active filter is provided, use the first one
//         if (!activeFilter) {
//             filters[0].classList.add('active');
//             activeFilter = filters[0];
//         }

//         const filter = activeFilter.getAttribute('data-filter').toLowerCase();

//         // Update filter classes
//         filters.forEach(el => el === activeFilter ? el.classList.add('active') : el.classList.remove('active'));

//         if (filter === 'all') {
//             document.querySelectorAll(`.swiper-container[data-slider="${sliderId}"] [data-filter]`).forEach(item => {
//                 item.classList.remove('non-swiper-slide');
//                 item.classList.add('swiper-slide');
//             });
//         } else {
//             // Hide non-matching slides
//             document.querySelectorAll(`.swiper-container[data-slider="${sliderId}"] [data-filter]:not([data-filter='${filter}'])`).forEach(item => {
//                 item.classList.add('non-swiper-slide');
//                 item.classList.remove('swiper-slide');
//                 item.removeAttribute('style');
//             });

//             // Show matching slides
//             document.querySelectorAll(`.swiper-container[data-slider="${sliderId}"] [data-filter='${filter}']`).forEach(item => {
//                 item.classList.remove('non-swiper-slide');
//                 item.classList.add('swiper-slide');
//                 item.removeAttribute('style');
//             });
//         }

//         // Update Swiper instance after filter changes
//         swiper.update();
//     }

//     // Attach click event listeners to each filter
//     filters.forEach(filter => {
//         filter.addEventListener('click', function (e) {
//             updateFilter(e.target);
//         });
//     });

//     // Initialize filter with the first one (if it exists)
//     updateFilter(null);
// });





var TwaSettingsSwiper = {
    init: function() {
        this.TwaSettingsCarousel()
    },
    TwaSettingsCarousel: function() {
        document.querySelectorAll(".twa__swiper").forEach(e => {
            this.TwaCarousel(e)
        })
    },
    TwaCarousel: function(e) {
        var t = e?.dataset.autoplay === "true",
            n = e.dataset.loop === "true",
            w = e?.dataset.rows ? e?.dataset.row : 1,
            o = e?.dataset.slideshow ? e?.dataset.slideshow : 0,
            pgm = e?.dataset.spgmobile ? e?.dataset.spgmobile : 1,
            pgt = e?.dataset.spgtablet ? e?.dataset.spgtablet : 1,
            pgd = e?.dataset.spgdesktop ? e?.dataset.spgdesktop : 1,
            i = e?.dataset.desktop ? e?.dataset.desktop : 4,
            s = e?.dataset.tablet ? e?.dataset.tablet : 2,
            r = e?.dataset.mobile ? e?.dataset.mobile : 1,
            a = e?.dataset.autoplaySpeed ? e?.dataset.autoplaySpeed : 3e3,
            c = e?.dataset.speed ? e?.dataset.speed : 400,
            l = e?.dataset.effect ? e?.dataset.effect : "slide",
            d = e?.dataset.sectionId,
            u = e?.dataset.row ? e?.dataset.row : 1,
            ut = e?.dataset.rowtablet ? e?.dataset.rowtablet : 1,
            um = e?.dataset.rowmobile ? e?.dataset.rowmobile : 1,
            p = window.innerWidth,
            m = e?.dataset.spacing ? e?.dataset.spacing : 0;
            cs = e.dataset.centerslide === "true", desktop = parseInt(pgd), tablet = parseInt(pgt), mobile = parseInt(pgm), al = e?.dataset.arrowleft ? e?.dataset.arrowleft : "swiper-button-prev", ar = e?.dataset.arrowright ? e?.dataset.arrowright : "swiper-button-next", m = Number(m), a = Number(a), c = Number(c), p <= 767 ? m >= 15 && (m = 15) : p <= 1199 && m >= 30 && (m = 30), new Swiper("#twa__swiper-" + d, {
            slidesPerView: r,
            slidesPerColumn: w,
            autoWidth: true,
            slidesPerGroup: mobile,
            spaceBetween: m,
            centeredSlides: cs,
            autoplay: t,
            delay: a,
            loop: n,
            effect: l,
            speed: c,
            watchSlidesProgress: !0,
            watchSlidesVisibility: !0,
            draggable: !0,
            grid: {
                rows: um,
                fill: "row"
            },
            navigation: {
                nextEl: `.${ar}`,
                prevEl: `.${al}`
            },
            pagination: {
                clickable: !0,
                el: e.querySelector(".swiper-pagination")
            },
            breakpoints: {
                768: {
                    slidesPerView: s,
                    centeredSlides: cs,
                    slidesPerGroup: tablet,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                1100: {
                    slidesPerView: i,
                    slidesPerGroup: desktop,
                    grid: {
                        rows: u,
                        fill: "row"
                    }
                }
            }
        })
    }
};
TwaSettingsSwiper.init(), document.addEventListener("shopify:section:load", function(event) {
    TwaSettingsSwiper.init()
})

let interval = setInterval(() => {
    const swiperElements = document.querySelectorAll('.twa__swiper');
    swiperElements.forEach(swiperElement => {
        if (swiperElement.classList.contains('product_recommendations_swiper')) {
            //console.log("Element with 'product_recommendations_swiper' class found. Stopping interval.");
            TwaSettingsSwiper.init();
            clearInterval(interval);
        }
    });
}, 1000);






// document.querySelectorAll('.swiper-container').forEach(swiperContainer => {
//     const sliderId = swiperContainer.getAttribute('data-slider');
//     const swiperConfig = {
//         pagination: {
//             el: `.swiper-container[data-slider="${sliderId}"] .swiper-pagination`,
//             clickable: true,
//             //type: "fraction"
//         },
//         navigation: {
//             nextEl: `.swiper-container[data-slider="${sliderId}"] .swiper-button-next`,
//             prevEl: `.swiper-container[data-slider="${sliderId}"] .swiper-button-prev`
//         },
//         slidesPerView: 1.4,
//         slidesPerColumn: 1,
//         spaceBetween: 20,
//         cssMode: true,
//         loop: false,
//         mousewheel: false,
//         keyboard: true,
//         allowTouchMove: false,
//         breakpoints: {
//             0: { slidesPerView: 1.4, slidesPerGroup: 1, spaceBetween: 15 },
//             768: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 30 },
//             960: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 40 }
//         }
//     };
//     let swiper = new Swiper(`.swiper-container[data-slider="${sliderId}"]`, swiperConfig);
//     const filters = document.querySelectorAll(`.categories[data-slider="${sliderId}"] span`);
//     function updateFilter(activeFilter) {
//         if (!activeFilter) {
//             filters[0].classList.add('active');
//             activeFilter = filters[0];
//         }
//         const filter = activeFilter.getAttribute('data-filter').toLowerCase();
//         filters.forEach(el => el === activeFilter ? el.classList.add('active') : el.classList.remove('active'));
//         if (filter === 'all') {
//             document.querySelectorAll(`.swiper-container[data-slider="${sliderId}"] [data-filter]`).forEach(item => {
//                 item.classList.remove('non-swiper-slide');
//                 item.classList.add('swiper-slide');
//             });
//         } else {
//             document.querySelectorAll(`.swiper-container[data-slider="${sliderId}"] [data-filter]:not([data-filter='${filter}'])`).forEach(item => {
//                 item.classList.add('non-swiper-slide');
//                 item.classList.remove('swiper-slide');
//                 item.removeAttribute('style');
//             });

//             document.querySelectorAll(`.swiper-container[data-slider="${sliderId}"] [data-filter='${filter}']`).forEach(item => {
//                 item.classList.remove('non-swiper-slide');
//                 item.classList.add('swiper-slide');
//                 item.removeAttribute('style');
//             });
//         }
//         swiper.update();
//     }
//     filters.forEach(filter => {
//         filter.addEventListener('click', function (e) {
//             updateFilter(e.target);
//         });
//     });
//     updateFilter(null);
// });



document.querySelectorAll('.swiper-container').forEach(swiperContainer => {
    const sliderId = swiperContainer.getAttribute('data-slider');
    const swiperConfig = {
        pagination: {
            el: `.swiper-container[data-slider="${sliderId}"] .swiper-pagination`,
            clickable: true,
        },
        navigation: {
            nextEl: `.swiper-container[data-slider="${sliderId}"] .swiper-button-next`,
            prevEl: `.swiper-container[data-slider="${sliderId}"] .swiper-button-prev`
        },
        slidesPerView: 1.4,
        slidesPerColumn: 1,
        spaceBetween: 20,
        cssMode: true,
        loop: false,
        mousewheel: false,
        keyboard: true,
        allowTouchMove: false,
        breakpoints: {
            0: { slidesPerView: 1.4, slidesPerGroup: 1, spaceBetween: 15 },
            768: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 30 },
            960: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 40 }
        }
    };

    let swiper = new Swiper(`.swiper-container[data-slider="${sliderId}"]`, swiperConfig);

    const filters = document.querySelectorAll(`.categories[data-slider="${sliderId}"] span`);

    function updateFilter(activeFilter) {
        // If there are no filters, return early to avoid errors
        if (filters.length === 0) {
            console.warn('No filters found for this slider.');
            return;
        }

        // If no active filter is provided, use the first one
        if (!activeFilter) {
            filters[0].classList.add('active');
            activeFilter = filters[0];
        }

        const filter = activeFilter.getAttribute('data-filter').toLowerCase();

        // Update filter classes
        filters.forEach(el => el === activeFilter ? el.classList.add('active') : el.classList.remove('active'));

        if (filter === 'all') {
            document.querySelectorAll(`.swiper-container[data-slider="${sliderId}"] [data-filter]`).forEach(item => {
                item.classList.remove('non-swiper-slide');
                item.classList.add('swiper-slide');
            });
        } else {
            // Hide non-matching slides
            document.querySelectorAll(`.swiper-container[data-slider="${sliderId}"] [data-filter]:not([data-filter='${filter}'])`).forEach(item => {
                item.classList.add('non-swiper-slide');
                item.classList.remove('swiper-slide');
                item.removeAttribute('style');
            });

            // Show matching slides
            document.querySelectorAll(`.swiper-container[data-slider="${sliderId}"] [data-filter='${filter}']`).forEach(item => {
                item.classList.remove('non-swiper-slide');
                item.classList.add('swiper-slide');
                item.removeAttribute('style');
            });
        }

        // Update Swiper instance after filter changes
        swiper.update();
    }

    // Attach click event listeners to each filter
    filters.forEach(filter => {
        filter.addEventListener('click', function (e) {
            updateFilter(e.target);
        });
    });

    // Initialize filter with the first one (if it exists)
    updateFilter(null);
});


